<template>
  <a-drawer title="消息详情" width="min(960px, 100vw)" wrapClassName="push-message-drawer" :visible="visible" @close="close">
    <div class="push-message-detail">
      <a-spin :spinning="loading">
        <a-alert v-if="error" class="detail-error" type="error" :message="error" showIcon />
        <template v-if="message">
          <section class="detail-section message-overview">
            <h2>{{ message.title || '消息详情' }}</h2>
            <div class="message-meta">
              <span v-if="!mine">所属租户：{{ message.tenantName || (message.tenantId === 0 ? '主租户' : '租户') }}（{{ message.tenantId }}）</span>
              <span><a-icon type="user"/> 接收人：{{ message.recipientName || '未记录' }}</span>
              <span><a-icon type="clock-circle"/> {{ message.createTime }}</span>
              <span v-if="message.sender">派发人：{{ message.sender }}</span>
            </div>
            <div class="message-text">{{ message.content || message.summary || '暂无消息内容' }}</div>
            <a-button v-if="mine && message.businessType !== 'WORK_PLAN' && message.viewFrom" @click="$emit('business', message)">查看业务详情</a-button>
          </section>

          <section class="detail-section">
            <div class="section-heading">
              <h3>关联事项 <span class="section-count">共 {{ message.total }} 条</span></h3>
              <a-select v-model="stage" class="stage-filter" :disabled="loading" @change="load(1)">
                <a-select-option value="">全部分类</a-select-option>
                <a-select-option v-for="(count,key) in counts" :key="key" :value="key">{{ labels[key] || key }}（{{ count }}）</a-select-option>
              </a-select>
            </div>
            <div v-if="!items.length" class="detail-empty">暂无符合条件的关联事项</div>
            <article v-for="(item,index) in items" :key="item.id || item.businessId || index" class="plan-card">
              <div class="plan-heading">
                <h4>{{ item.title || item.businessId || '关联事项' }}</h4>
                <a-tag :color="stageColors[item.stage]">{{ labels[item.stage] || item.stage }}</a-tag>
              </div>
              <div v-if="item.changeSummary || item.content" class="change-summary">
                <span class="field-label">通知内容</span>
                <p class="message-text">{{ item.changeSummary || item.content }}</p>
              </div>
              <dl v-if="item.plan" class="plan-fields">
                <div><dt>站点名称</dt><dd>{{ item.plan.siteName || '未设置' }}</dd></div>
                <div><dt>截止时间</dt><dd>{{ item.plan.endTime || '未设置' }}</dd></div>
                <div><dt>待完成项目</dt><dd>{{ item.plan.remaining == null ? '-' : item.plan.remaining }} 项</dd></div>
                <div v-if="item.latestStatus"><dt>最新状态</dt><dd>{{ statuses[item.latestStatus] || item.latestStatus }}</dd></div>
                <div class="full-field"><dt>执行项目</dt><dd>{{ (item.plan.projectNames || []).join('、') || '无' }}</dd></div>
                <div v-if="item.plan.remark" class="full-field"><dt>计划备注</dt><dd class="message-text">{{ item.plan.remark }}</dd></div>
              </dl>
              <p v-else-if="item.latestStatus" class="field-label">最新状态：{{ statuses[item.latestStatus] || item.latestStatus }}</p>
              <a-button v-if="item.canView" size="small" icon="file-text" @click="openPlan(item.planId)">查看计划详情</a-button>
            </article>
            <div v-if="total > 20" class="detail-pagination">
              <a-pagination :current="current" :pageSize="20" :total="total" :disabled="loading" @change="load"/>
            </div>
          </section>

          <section v-if="!mine" class="detail-section">
            <div class="section-heading"><h3>渠道发送结果</h3><span class="field-label">各渠道独立记录</span></div>
            <div v-if="!deliveries.length" class="detail-empty">暂无渠道发送记录</div>
            <article v-for="delivery in deliveries" :key="delivery.id" class="delivery-card">
              <div class="delivery-heading">
                <h4>{{ channels[delivery.channel] || delivery.channel }}</h4>
                <a-tag :color="deliveryColors[delivery.state]">{{ deliveryLabels[delivery.state] || delivery.state }}</a-tag>
                <span class="attempt-count">已尝试 {{ delivery.attempts || 0 }} 次</span>
              </div>
              <dl class="delivery-fields">
                <div><dt>结果码</dt><dd>{{ delivery.lastCode || '-' }}</dd></div>
                <div><dt>供应商编号</dt><dd>{{ delivery.providerId || '-' }}</dd></div>
              </dl>
              <p v-if="resultMessage(delivery.resultPayload)" class="result-message">{{ resultMessage(delivery.resultPayload) }}</p>
              <a-collapse :bordered="false">
                <a-collapse-panel key="params" header="实际发送参数"><pre class="payload-json">{{ json(delivery.requestPayload) }}</pre></a-collapse-panel>
                <a-collapse-panel key="result" header="发送返回结果"><pre class="payload-json">{{ json(delivery.resultPayload) }}</pre></a-collapse-panel>
              </a-collapse>
            </article>
          </section>
        </template>
      </a-spin>
    </div>
    <work-plan-modal ref="planModal" pagePath="/om/work/plan"/>
  </a-drawer>
</template>
<script>
import { getAction, putAction } from '@/api/manage'
import WorkPlanModal from '@/views/om/plan/modules/WorkPlanModal'
/** 完整通知详情，展示业务清单、当前状态及独立渠道结果。 */
export default {
  components: { WorkPlanModal },
  /** 分别保存本人关联清单与管理员可查看的渠道结果。 */
  data() { return { visible:false,loading:false,error:'',message:null,items:[],counts:{},deliveries:[],mine:true,id:'',stage:'',current:1,total:0,loadVersion:0,
    deliveryLabels:{PENDING:'待发送',SENDING:'提交中',SUBMITTED:'已提交',FAILED:'失败',SKIPPED:'跳过',CANCELLED:'已取消',EXPIRED:'已过期',UNKNOWN:'结果未知'},
    channels:{APP:'App 推送',WECHAT:'微信推送',SMS:'短信推送'},
    deliveryColors:{PENDING:'orange',SENDING:'blue',SUBMITTED:'green',FAILED:'red',UNKNOWN:'purple'},
    stageColors:{TODAY:'orange',OVERDUE:'red',AFTER_TOMORROW:'blue',ASSIGNED:'blue',RELEASED:'default',CHANGED:'cyan'},
    labels:{ TODAY:'今日到期',OVERDUE:'逾期',AFTER_TOMORROW:'后天到期',ASSIGNED:'安排',RELEASED:'解除',CHANGED:'变更',NOTICE:'通知' },
    statuses:{ '1':'未完成','2':'已完成',PAUSED:'已暂停',DELETED:'已删除',RELEASED:'已解除执行安排' } } },
  methods: {
    /** 打开指定消息并重置此前详情及筛选。 */
    open(id,mine=true) {
      this.id=id;this.mine=mine;this.visible=true;this.error='';this.message=null;this.items=[];this.counts={};this.deliveries=[];this.stage='';this.current=1;this.total=0;this.load(1)
    },
    /** 关闭后使未完成请求失效，避免旧结果覆盖再次打开的消息。 */
    close() { this.visible=false;this.loadVersion++;this.loading=false;this.$emit('close') },
    /** 按本人或管理员身份读取关联分页，本人查看后标记已读。 */
    async load(current) {
      const version=++this.loadVersion
      const id=this.id,mine=this.mine
      this.loading=true;this.error=''
      try {
        const url='/sys/push/messages'+(mine ? '/mine' : '')+'/'+id
        const res=await getAction(url,{current,size:20,stage:this.stage || undefined})
        if(version!==this.loadVersion || !this.visible)return
        if(!res.success)throw new Error(res.message || '加载失败')
        this.message=res.result.message;this.items=res.result.items.records;this.counts=res.result.counts;this.deliveries=res.result.deliveries || []
        this.current=res.result.items.current;this.total=res.result.items.total
        // 管理员查看不改变接收人的已读状态。
        if(mine && !this.message.readAt) {
          const readRes=await putAction(url+'/read')
          if(!readRes.success)throw new Error(readRes.message || '标记已读失败，请重试')
          this.$emit('read',id)
        }
      }catch(e){if(version===this.loadVersion)this.error=e.message || '加载失败'}finally{if(version===this.loadVersion)this.loading=false}
    },
    /** 重新读取计划，依赖服务端当前权限决定能否查看。 */
    async openPlan(id) {
      const res=await getAction('/om/work/plan/'+id)
      if(!res.success){this.$message.warning(res.message);return}
      this.$refs.planModal.edit(res.result);this.$refs.planModal.title='计划详情';this.$refs.planModal.disableSubmit=true
    },
    /** 格式化实际参数和返回结果，保留无法解析的原内容。 */
    json(value) { if(value==null || value==='')return '-';try{return JSON.stringify(typeof value==='string' ? JSON.parse(value) : value,null,2) || '-'}catch(e){return value || '-'} },
    /** 从供应商结果提取错误说明，完整返回仍保留在折叠区。 */
    resultMessage(value) { try{const result=typeof value==='string' ? JSON.parse(value) : value;return result && (result.message || result.msg) || ''}catch(e){return ''} }
  }
}
</script>
<style lang="less">
// 抽屉挂载到 body，用专属类限定覆盖范围，避免深色全局主题降低详情文字对比度。
.push-message-drawer.ant-drawer {
  .ant-drawer-content, .ant-drawer-wrapper-body { background: #f4f6f9 !important; color: #303133; }
  .ant-drawer-header { background: #fff !important; border-bottom: 1px solid #e8edf3; }
  .ant-drawer-title { color: #1f2937 !important; font-weight: 600; }
  .ant-drawer-close { color: #606266 !important; }
  .ant-drawer-close:hover { color: #1890ff !important; }
  .ant-drawer-body { padding: 24px; }
  .push-message-detail {
    color: #303133;
    .detail-section { margin-bottom: 20px; padding: 22px; border: 1px solid #e8edf3; border-radius: 6px; background: #fff; }
    h2, h3, h4 { color: #1f2937; font-weight: 600; overflow-wrap: anywhere; }
    h2 { margin: 0 0 14px; font-size: 20px; line-height: 1.5; }
    h3 { margin: 0; font-size: 16px; }
    h4 { margin: 0; font-size: 15px; }
    .message-meta { display: flex; flex-wrap: wrap; gap: 8px 20px; margin-bottom: 16px; color: #768194; font-size: 13px; }
    .message-text { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.8; color: #303133; }
    .message-overview > .message-text { padding: 14px 16px; background: #f7f9fc; border-radius: 4px; }
    .message-overview > .ant-btn { margin-top: 14px; }
    .section-heading { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 18px; }
    .section-count { margin-left: 8px; color: #909399; font-size: 13px; font-weight: normal; }
    .stage-filter { width: 200px; }
    .plan-card, .delivery-card { margin-bottom: 14px; padding: 18px; border: 1px solid #e8edf3; border-radius: 4px; }
    .plan-card:last-child, .delivery-card:last-child { margin-bottom: 0; }
    .plan-heading, .delivery-heading { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-bottom: 14px; }
    .ant-tag { margin: 0; }
    .change-summary { margin-bottom: 16px; padding: 12px 14px; background: #f7f9fc; border-left: 3px solid #91caff; border-radius: 3px; }
    .field-label { color: #768194; font-size: 13px; }
    .plan-fields { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 14px 24px; margin-bottom: 18px; }
    // 避免 Less 将跨列语法按除法计算，执行项目和备注必须横跨整行。
    .full-field { grid-column: ~"1 / -1"; }
    dt { margin-bottom: 5px; color: #768194; font-size: 13px; font-weight: normal; }
    dd { margin: 0; color: #303133; line-height: 1.7; overflow-wrap: anywhere; }
    .delivery-fields { display: grid; grid-template-columns: 120px minmax(0,1fr); gap: 16px; margin-bottom: 14px; }
    .attempt-count { margin-left: auto; color: #909399; font-size: 13px; }
    .result-message { padding: 10px 12px; color: #596579; background: #f7f9fc; border-radius: 4px; overflow-wrap: anywhere; }
    .ant-collapse { background: #f7f9fc; border-radius: 4px; }
    .ant-collapse-header { color: #4b5563 !important; }
    .ant-collapse-content { background: #fff; color: #303133; }
    .payload-json { margin: 0; padding: 14px; max-height: 360px; overflow: auto; color: #334155; background: #f7f9fc; border: 1px solid #edf0f4; border-radius: 4px; font-size: 12px; line-height: 1.7; white-space: pre-wrap; overflow-wrap: anywhere; }
    .detail-pagination { display: flex; justify-content: flex-end; margin-top: 18px; }
    .ant-pagination, .ant-pagination-item a, .ant-pagination-item-link { color: #606266 !important; }
    .ant-pagination-item, .ant-pagination-item-link { background: #fff !important; }
    .ant-pagination-item-active { background: #e6f7ff !important; }
    .ant-pagination-item-active a { color: #1890ff !important; }
    .ant-pagination-disabled .ant-pagination-item-link { color: #c0c4cc !important; }
    .detail-empty { padding: 24px; color: #909399; text-align: center; background: #f7f9fc; border-radius: 4px; }
    .detail-error { margin-bottom: 18px; }
  }
}
@media (max-width: 600px) {
  .push-message-drawer.ant-drawer {
    .ant-drawer-body { padding: 12px; }
    .push-message-detail {
      .detail-section { padding: 16px; }
      .plan-card, .delivery-card { padding: 14px; }
      .plan-fields, .delivery-fields { grid-template-columns: minmax(0,1fr); }
      .stage-filter { width: 100%; }
    }
  }
}
</style>
